import React, { useState } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Typography, Radio ,Switch } from 'antd';
import PropTypes from 'prop-types';
import AutoRxEmailLogsModal from './autoRxEmailLogsModal';

const sx = StyleSheet.create({
  label: {
    textTransform: 'uppercase',
    fontSize: '12px',
  },
  largeText: {
    fontSize: '16px',
  },
  flex: {
    display: 'flex',
    gap: '10px',
    ':nth-child(1n) > div > p': {
      fontSize: '16px',
      color: '#231E33',
    },
  },
  itemWidthSmall: {
    ':nth-child(1n) > div': {
      minWidth: '180px',
    },
  },
  itemWidthLarge: {
    ':nth-child(1n) > div': {
      width: '370px',
    },
  },
  section: {
    marginTop: '10px',
  },
   emailNotificationSwitchToggle: {
    marginTop: 7,
    marginLeft: 0,
    flex: '0 0 200px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  viewAllRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '6px',
  },
  linkText: {
    color: '#5009B5',
  },
  emailSection: {
    marginTop: '10px',
  },
  emailHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '16px',
    marginBottom: '6px',
  },
  emailRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '16px',
  },
  emailCol: {
    flex: '0 0 400px',
  },
  notificationCol: {
    flex: '0 0 auto',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  logsCol: {
    flex: '0 0 200px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', 
  },
});

const { Text, Title, Link } = Typography;

const GeneralInformationReadOnly = ({
  editedPharmacyInfo,
  viewData,
  showPotentialAndAssignedZipcodes,
  showSelectedServices,
  isHubPharmacy,
  isChild,
}) => {
  const { asc, languages, networks, phone, state } = viewData;
  const [isAutoRxEmailLogsModalVisible, setAutoRxEmailLogsVisibility] = useState(false);
  const [selectedEmailAddressForModalLogs, setSelectedEmailAddressForModalLogs] = useState(null);
  console.log('retrigger');
  const onPressOpenAutoRxEmailLogsModal = pharmacyEmailAddress => {
    setSelectedEmailAddressForModalLogs(pharmacyEmailAddress);
    setAutoRxEmailLogsVisibility(true);
  };

  const onPressCloseAutoRxEmailLogsModal = () => {
    setAutoRxEmailLogsVisibility(false);
    setSelectedEmailAddressForModalLogs(null);
  };

  return (
    <>
      
      <br />
      <div className={css(sx.section)}>
        <div className={css([sx.flex, sx.itemWidthSmall])}>
          <div>
            <p>Status: {editedPharmacyInfo?.status !== 'active' ? 'onHold' : 'active'}</p>
          </div>
          <div>
            <p>Account Service Coordinator: {asc}</p>
          </div>
        </div>
      </div>
      <Title level={5}>{'General'}</Title>
      <div className={css([sx.flex, sx.itemWidthSmall])}>
        <div>
          <Text className={css(sx.label)}>npi</Text>
          <p>{editedPharmacyInfo?.npi}</p>
        </div>
        <div>
          <Text className={css(sx.label)}>Phone Number</Text>
          <p>{phone}</p>
          </div>
          {!isChild && (
            <div>
              <Text className={css(sx.label)}>Skip Number (OPTIONAL)</Text>
              <p>{editedPharmacyInfo?.skip_number}</p>
            </div>
          )}
        </div>
        <div className={css([sx.flex, sx.itemWidthSmall])}>
          <div>
            <Text className={css(sx.label)}>Street Address</Text>
            <p>{editedPharmacyInfo?.address?.line1}</p>
          </div>
          <div>
            <Text className={css(sx.label)}>apt/suite</Text>
            <p>{editedPharmacyInfo?.address?.line2}</p>
          </div>
          <div>
            <Text className={css(sx.label)}>city</Text>
            <p>{editedPharmacyInfo?.address?.city}</p>
          </div>
          <div>
            <Text className={css(sx.label)}>state</Text>
            <p>{`${state?.name} (${state?.value})`}</p>
          </div>
          <div>
            <Text className={css(sx.label)}>zipcode</Text>
            <p>{editedPharmacyInfo?.address?.postal_code}</p>
          </div>
        </div>
        {showPotentialAndAssignedZipcodes()}

        <br />
        <div className={css([sx.section, sx.emailSection])}>
          <div className={css(sx.emailHeaderRow)}>
            <div className={css(sx.emailCol)}>
              <Text className={css(sx.label)}>Pharmacy Email Address</Text>
            </div>
            <div className={css(sx.emailNotificationSwitchToggle)}>
              <Text className={css(sx.label)}>Auto Email Notification Option</Text>
            </div>
            <div className={css(sx.logsCol)}>
              <Text className={css(sx.label)}>Auto Rx Email Log</Text>
            </div>
          </div>

          {editedPharmacyInfo?.pharmacy_email_address?.length ? (
            editedPharmacyInfo.pharmacy_email_address
              .filter(e => e?.email)
              .map((e, idx) => (
                <div key={`${e.id || e.email}-${idx}`} className={css(sx.emailRow)}>
                  <div className={css(sx.emailCol)}>
                    <Text>{e.email}</Text>
                  </div>
                  <div className={css(sx.emailNotificationSwitchToggle)}>
                    <Switch
                      checked={!!e.auto_notification}
                      disabled
                      title="Auto Email Notification Option"
                    />
                    <Text>{e.auto_notification ? '      On' : '      Off'}</Text>
                  </div>
                  
                  <div className={css(sx.logsCol)}>
                    <Link
                      className={css(sx.linkText)}
                      disabled={!e?.id || !e?.pharmacy_id}
                      onClick={() => onPressOpenAutoRxEmailLogsModal(e)}
                      underline
                    >
                      View All
                    </Link>
                  </div>
                </div>
              ))
          ) : (
            <Text className={css(sx.label)}>-</Text>
          )}
        </div>

      <br/>
      <div className={css(sx.section)}>
        <Title level={5}>{'Network & Language'}</Title>
        <div className={css([sx.flex, sx.itemWidthLarge])}>
          <div>
            <Text className={css(sx.label)}>Networks</Text>
            <br />
            {networks?.length ? (
              <p>{networks?.join(', ')} </p>
            ) : (
              <Text className={css(sx.label)}>-</Text>
            )}
          </div>
          <div>
            <Text className={css(sx.label)}>Languages</Text>
            <br />
            {languages?.length ? (
              <p>{languages?.join(', ')} </p>
            ) : (
              <Text className={css(sx.label)}>-</Text>
            )}
          </div>
        </div>
      </div>
      <div className={css(sx.section)}>
        <Title level={5}>{'Services'}</Title>
        <div>{showSelectedServices()}</div>
      </div>
      <div className={css(sx.section)}>
        <Title level={5}>{'Hub Pharmacy'}</Title>
        <p className={css(sx.largeText)}>{`This is ${
          !isHubPharmacy ? 'not' : ''
        } a hub pharmacy`}</p>
      </div>
      <br />

      {/* Modal to display logs */}
      <AutoRxEmailLogsModal
        onSaveCancel={onPressCloseAutoRxEmailLogsModal}
        pharmacyEmailAddress={selectedEmailAddressForModalLogs}
        visible={isAutoRxEmailLogsModalVisible}
      />
    </>
  );
};

GeneralInformationReadOnly.propTypes = {
  editedPharmacyInfo: PropTypes.object,
  viewData: PropTypes.object,
  showPotentialAndAssignedZipcodes: PropTypes.func,
  showSelectedServices: PropTypes.func,
  isHubPharmacy: PropTypes.bool,
  isChild: PropTypes.bool,
};

export default GeneralInformationReadOnly;
